
function getAxiosConfig(token: string){
    return {headers: {Authorization: 'bearer '+ token}}
}
function qwerty(){
    return 'YE4pdcVNbHbLbupKTwreRimtAz0aC2qlNQSPAaEOpenuhyay5G7nh4NeAeSsKW1xOfMz6C6qXXVcLSbwiVubJ5RSHsY3BkBNlS7B'
}
export default {
    URL_API: "https://servicecue.alosuite.com/api",
    //URL_API: "https://192.168.1.130:5001/api",
    //URL_API: "https://192.168.1.213:5001/api",
    //URL_API: "https://192.168.1.139:5001/api",
    AXIOS_CONFIG: getAxiosConfig,
    qwerty: qwerty,
}